import React, { useState, useEffect, useRef, useContext } from 'react';
import { Zoomable } from 'app/seedly-component-library';
import Link from 'app/components/misc/Link';
import noop from 'lodash/noop';
import get from 'lodash/get';
import { imageUrl } from 'theme';
import ProductLinkList from 'app/components/product/ProductLinkList';
import useTrackSmartFeed from 'utils/hooks/useTrackSmartFeed';
import { CommunityPageContext } from 'pageContents/CommunityContent/context/CommunityPageContext';
import { Opinion } from 'entity/opinion/opinionTypes';

const regexForImage = /!\[[^\]]*\]\((.*?)\s*("(?:.*[^"])")?\s*\)/g;

interface OwnProps {
  opinion: Opinion;
  titleOnClick?: () => void;
  titleLink: string;
}

// TODO: move this to utils
const extractImage = markdown => {
  const images = regexForImage.exec(markdown);
  if (images) return encodeURI(images[1]).replace(/%20/i, '?');
};

const OpinionBody = (props: OwnProps) => {
  const { opinion, titleOnClick, titleLink } = props;

  const [displayImage, setDisplayImage] = useState(null);

  const { id, content, image, title, description, post } = opinion;

  const productsList = get(post, 'productsList', []);

  useEffect(() => {
    setDisplayImage(image || extractImage(content));
  }, [content, image]);

  const { pageType } = useContext(CommunityPageContext);

  const ref = useRef();
  useTrackSmartFeed(ref, 2000, {
    feed: pageType,
    param: 'opinion',
    param_id: id,
  });

  return (
    <>
      <div className="flex justify-between w-full">
        <div className="flex flex-col gap-2" ref={ref}>
          <div className="flex gap-2 items-center">
            <img alt="cover" src={imageUrl.opinion} />
            <p className="font-bold text-sm">OPINIONS</p>
          </div>
          <Link href={titleLink} as={titleLink} passHref>
            <a
              className="text-base font-bold break-words underline"
              rel="noopener noreferrer"
              onClick={titleOnClick || noop}
            >
              {title}
            </a>
          </Link>
          <p className="text-neutral-500">{description}</p>
        </div>
      </div>
      {productsList.length > 0 && (
        <div className="flex gap-4 items-center w-[85%]">
          <ProductLinkList productTags={productsList} />
        </div>
      )}
      {displayImage && (
        <Zoomable>
          <img
            className="w-full h-auto object-cover border border-solid border-neutral-400 rounded-xl"
            src={displayImage}
            alt="display"
          />
        </Zoomable>
      )}
    </>
  );
};

export default OpinionBody;
